import axios from "axios";
var base64 = require('base-64');
var md5 = require('md5');
import config from "config/index";
import { getGlobal } from "config/global";
let host = config.host + "/api/"
let apikey = config.apikey
// initializing the axios instance with custom configs
export default function (address, title, name, text, status) {
    let token = localStorage.getItem("token")
    return axios.post(host + `tour/AddChatRoom`, {
        address, title, name, text, status
    },
        {
            headers: {
                "Content-Type": "application/json",
                "ApiKey": apikey,
                "Authorization": "Bearer " + token
            }
        }).then((response) => {
            return response.data
        }).catch((err) => {
            if (err?.response?.status == 401)
                { localStorage.removeItem("token"); window.location=("/auth/signin"); return toast.error("لطفا مجددا لاگین کنید.", {position: "bottom-right"})}
            else
            throw err;
        })
}